import { Route } from "react-router";
import AuthorizedRoute from "../../components/routing/authorized-route";
import ClientProfile from "./client-profile.highorder";
import { ClientProfileEditAlerts } from "./client-profile-edit-alerts.highorder";
import { ClientProfileEditAccess } from "./client-profile-edit-access.highorder";
import ClientProfileEditCamera from "./client-profile-edit-camera.highorder";

const ProtectedClientProfile = () => {
  return <AuthorizedRoute component={ClientProfile} />;
};

const ProtectedClientProfileEditAlerts = () => {
  return <AuthorizedRoute component={ClientProfileEditAlerts} />;
};

const ProtectedClientProfileEditAccess = (props: any) => {
  return <AuthorizedRoute component={ClientProfileEditAccess} />;
};

const ProtectedClientProfileEditCamera = (props: any) => {
  return <AuthorizedRoute component={ClientProfileEditCamera} />;
};

const clientProfileRoute = (
  <Route path="/client-profile">
    <Route
      path="alert-settings/:id"
      element={<ProtectedClientProfileEditAlerts />}
    />
    <Route
      path="access-settings/:id"
      element={<ProtectedClientProfileEditAccess />}
    />
    <Route path=":id" element={<ProtectedClientProfile />} />
    <Route
      path="camera-settings/:id"
      element={<ProtectedClientProfileEditCamera />}
    />
  </Route>
);

export default clientProfileRoute;
